import { PanelRow, ToggleControl, TextControl, SelectControl, Disabled } from '@wordpress/components'
import { useSelect, dispatch } from '@wordpress/data'
import { applyFilters } from '@wordpress/hooks';
import { __ } from '@wordpress/i18n'

export default data => {
    const store = useSelect(select => select('WPTravel/Admin'))
    const settings = store.getAllStore()

    const {
        force_cart_checkout_process_for_trips, 
        skip_cart_page_booking, 
        price_unavailable_text, 
        selected_booking_option, 
        enable_multiple_checkout,
        modules,
        options
    } = settings
    const { updateSettings } = dispatch('WPTravel/Admin');

    let force_checkout = 'undefined' != typeof force_cart_checkout_process_for_trips ? force_cart_checkout_process_for_trips : 'no'
    let skip_cart_page = 'undefined' != typeof skip_cart_page_booking ? skip_cart_page_booking : 'no'
    let multiple_cart_items = 'undefined' != typeof enable_multiple_checkout ? enable_multiple_checkout : 'no'

    let booking_options = [
        {'value' :'booking-only', 'label':'Booking only'},
        {'value' :'booking-with-payment', 'label':'Booking with payment'},
    ]
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings && 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;
    if ( ! isActive ) {
        // To hide while disabling from addons settings.
        return <></>;
    }
    return <>
        {applyFilters('wp_travel_settings_tab_before_cart_content', [], settings )}
    
        <Disabled className="hidden">
        <PanelRow>
            <label>{ __( 'Force Cart / Checkout', 'wp-travel-pro' ) }</label>
            <div className="wp-travel-field-value">
                <ToggleControl
                    checked={ force_checkout == 'yes' }
                    onChange={ () => {
                        updateSettings({
                            ...settings,
                            force_cart_checkout_process_for_trips: 'yes' == force_checkout ? 'no': 'yes'
                        })
                    } }
                />
                <p className="description">{__( 'Force Cart / Checkout Process for Bookings, even when no payment gateways are enabled.', 'wp-travel-pro' )}</p>
            </div>
        </PanelRow>
        <PanelRow>
            <label>{ __( 'Skip Cart Page', 'wp-travel-pro' ) }</label>
            <div className="wp-travel-field-value">
                <ToggleControl
                    checked={ skip_cart_page == 'yes' }
                    onChange={ () => {
                        updateSettings({
                            ...settings,
                            skip_cart_page_booking: 'yes' == skip_cart_page ? 'no': 'yes'
                        })
                    } }
                />
                <p className="description">{__( 'Skip Cart Page and take users directly to checkout on bookings.', 'wp-travel-pro' )}</p>
            </div>
        </PanelRow>
        </Disabled>
        <PanelRow>
            <label>{_wp_travel.setting_strings.checkout.price_unavailable_text}</label>
            <div id="wp-travel-checkout-price-unavailable-text" className="wp-travel-field-value">
                <TextControl
                    value={ price_unavailable_text }
                    onChange={ (value) => {
                        updateSettings({
                            ...settings,
                            price_unavailable_text: value
                        })
                    } }
                />
                <p className="description">{_wp_travel.setting_strings.checkout.price_unavailable_text_note}</p>
            </div>
        </PanelRow>
        <PanelRow>
            <label>{_wp_travel.setting_strings.checkout.select_booking_option}</label>
            <div id="wp-travel-checkout-select-booking" className="wp-travel-field-value">
                <SelectControl
                    multiple
                    // label={ __( '' ) }
                    value={ selected_booking_option }
                    onChange={ ( values ) => { 
                        updateSettings({
                            ...settings,
                            selected_booking_option: values
                        })
                    } }
                    options={ booking_options }
                />
                <p className="description">{_wp_travel.setting_strings.checkout.select_booking_option_note}</p>
            </div>
        </PanelRow>
        <PanelRow>
            <label >{_wp_travel.setting_strings.checkout.enable_multiple_checkout_add_to_cart}</label>
            <div id="wp-travel-checkout-enable-multiple-checkout" className="wp-travel-field-value">
                <ToggleControl
                    checked={ multiple_cart_items == 'yes' }
                    onChange={ () => {
                        updateSettings({
                            ...settings,
                            enable_multiple_checkout: 'yes' == multiple_cart_items ? 'no': 'yes'
                        })
                    } }
                />
                <p className="description">{_wp_travel.setting_strings.checkout.enable_multiple_checkout_add_to_cart_note}</p>
            </div>
        </PanelRow>
        {applyFilters('wp_travel_settings_tab_after_cart_content', [], settings )}
    </>
}